<template>
    <div class="pagination-container">
        <PaginationSizes @changedPageSize="changedPageSize"></PaginationSizes>

        <PaginationResults></PaginationResults>

        <slot></slot>

        <PaginationSizes @changedPageSize="changedPageSize"></PaginationSizes>

        <PaginationResults></PaginationResults>

        <Pagination @changedPage="changedPage"></Pagination>
    </div>
</template>

<script>
    import Pagination from "./Pagination";
    import PaginationSizes from "./PaginationSizes";
    import PaginationResults from "./PaginationResults";
    
    export default {
        name: "PaginationContainer",

        components: {
            PaginationResults,
            PaginationSizes,
            Pagination,
        },

        emits: [
            'changedPage',
            'changedPageSize',
        ],

        methods: {
            changedPage(page) {
                this.$emit('changedPage', page);
            },

            changedPageSize(pageSize) {
                this.$emit('changedPageSize', pageSize);
            },

        },
        
    }
</script>

<style scoped>
    .pagination-sizes {
        float: right;
    }

    .pagination-results {
        margin: 5px 0 10px;
    }
</style>